import React from 'react'

const TimesIcon = props => (
  <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.4061 1.02295C5.15642 -0.226726 3.1303 -0.226726 1.88062 1.02295C0.63094 2.27263 0.63094 4.29876 1.88062 5.54844L6.47502 10.1428L1.88062 14.7372C0.63094 15.9869 0.630939 18.013 1.88062 19.2627C3.13029 20.5124 5.15642 20.5124 6.4061 19.2627L11.0005 14.6683L15.5949 19.2627C16.8446 20.5124 18.8707 20.5124 20.1204 19.2627C21.3701 18.013 21.3701 15.9869 20.1204 14.7372L15.526 10.1428L20.1204 5.54844C21.3701 4.29876 21.3701 2.27263 20.1204 1.02295C18.8707 -0.226727 16.8446 -0.226726 15.5949 1.02295L11.0005 5.61735L6.4061 1.02295Z"
      fill="currentColor"
    />
  </svg>
)

export default TimesIcon
